import { lazyWithPreload } from "utils/lazyWithPreload"

const Users = lazyWithPreload(() => import("pages/common/Users"))
const ReleaseNotes = lazyWithPreload(() => import("pages/common/ReleaseNotes"))
const ReleaseNoteDetail = lazyWithPreload(() => import("pages/common/ReleaseNotes/ReleaseNoteDetail"))
// const Settings = lazyWithPreload(() => import("pages/common/Settings"))

export const universalRoutes = [
  {
    path: "/users",
    component: Users,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Users" }] },
    internal: false,
  },
  {
    path: "/release-notes",
    component: ReleaseNotes,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Release Notes" }] },
    internal: false,
  },
  {
    path: "/release-notes/:publicId",
    component: ReleaseNoteDetail,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Release Notes" }] },
    internal: false,
  },

  // TODO: SETTINGS removed until further notice
  // {
  //   path: "/settings",
  //   component: Settings,
  //   meta: { breadcrumb: [{ parent: "Dashboard", label: "Settings" }] },
  // },
]
